module.exports = __webpack_public_path__ + "static/media/img-about-us.bbee844d.jpg";